module.exports = __webpack_public_path__ + "media/images/social/pinterest-brands-0c2fee055ea5ebb3a1ed8096f94d32a0.svg";